import { TextDirection } from '../../model/enums';
import { RTL_LANGUAGES } from '../../config';

export const getDirectionality = (lnCode: string): TextDirection =>
  !lnCode || !RTL_LANGUAGES.includes(lnCode) ? TextDirection.LTR : TextDirection.RTL;
